__turbopack_context__.v({
  "className": "mulish_20608841-module__PM9rRG__className",
});
